import React, { Component } from "react";
import { css } from "glamor";
import * as R from "ramda";
import { Query } from "react-apollo";

import { debounce } from "../../util";
import ApolloPaginationTable from "../../container/ApolloPaginationTable";
import { getTaskColumns } from "./TasksTableColumns";
import { GET_TASK_PERMISSIONS } from "./queries";

const styles = {
    td: css({
        padding: "10px 7px !important",
        alignItems: "center",
        display: "flex",
    }),
    theadTh: css({
        padding: "10px 7px !important",
        "& input, & .ant-select": {
            fontSize: 13,
        },
    }),
    table: css({
        fontSize: 13,
    }),
};

class TasksSearchTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: [],
            sortings: [],
        };
        this.columns = permissionsData =>
            getTaskColumns(
                "node",
                this.handleFilteredChange,
                props.nameRenderer,
                permissionsData,
                this.preventSort
            );
    }

    // Prevent sorting change when clicking on input if table <Header> is input field
    preventSort = e => {
        e.stopPropagation();
    };

    applyFilteredChange = (filters, additionalState) => {
        this.setState(
            prevState => ({
                // remove keys with empty values
                filters: R.pickBy(R.complement(R.isEmpty), {
                    ...prevState.filters,
                    ...filters,
                }),
                ...additionalState,
            }),
            this.handleRefetchConnection
        );
    };

    handleFilteredChange = debounce(this.applyFilteredChange, 750);

    handleSortedChange = sortings => {
        const { id } = sortings[0];
        let newSortings = [];

        if (R.any(R.propEq("id", id))(this.state.sortings)) {
            newSortings = this.state.sortings.map(sorting =>
                sorting.id === id ? sortings[0] : sorting
            );
        } else {
            newSortings = [...this.state.sortings, ...sortings];
        }

        const ordering = newSortings.map(
            sorting => (sorting.desc ? "-" : "") + sorting.id
        );
        this.applyFilteredChange({ ordering }, { sortings: newSortings });
    };

    handleRefetchConnection = () => {
        const filters = [
            "taskName",
            "entityName",
            "processName",
            "countryCode",
            "linesOfBusiness",
            "linesOfBusinessSearchOperator",
            "ordering",
            "createdAfter",
            "createdBefore",
            "ownerIds",
        ];

        const refVars = R.pickAll(filters, this.state.filters);
        this.props.apolloProps.refetch(refVars);
    };

    render() {
        return (
            <Query fetchPolicy="cache-only" query={GET_TASK_PERMISSIONS}>
                {({ data, loading, error }) => {
                    if (error) {
                        return <div>{error.message}</div>;
                    } else if (loading || !data.permissions) {
                        return <div>Loading...</div>;
                    } else {
                        return (
                            <ApolloPaginationTable
                                getTdProps={() => ({
                                    className: `${styles.td}`,
                                })}
                                getTheadThProps={() => ({
                                    className: `${styles.theadTh}`,
                                })}
                                getTableProps={() => ({
                                    className: `${styles.table}`,
                                })}
                                onSortedChange={this.handleSortedChange}
                                sorted={this.state.sortings}
                                apolloProps={this.props.apolloProps}
                                columns={this.columns(data)}
                            />
                        );
                    }
                }}
            </Query>
        );
    }
}

export default TasksSearchTable;
